import styles from './AccountOverview.module.css';

export const AccountOverview = () => {
  return (
    <div className={styles.pageContent}>
      <h2 className={styles.heading}>Account overview</h2>
      {/* TODO: add in this ticket https://iwoca.atlassian.net/browse/BF-44 */}
    </div>
  );
};
